import { FormControlLabel, Switch, SwitchProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import * as React from 'react'

interface KSwitchProps {
  label: string
  checked?: boolean
  disabled?: boolean
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
}

export const KSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => {
  const sizes = {
    default: 5,
    smallDown: 4.5,
  }
  return {
    height: theme.spacing(sizes.default),
    width: theme.spacing(sizes.default * 2),
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: theme.spacing(0.5),
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${theme.spacing(sizes.default)})`,
        color: theme.palette.grey[50],
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.success.main,
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.success['900'],
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: theme.palette.success['400'],
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: theme.spacing(sizes.default - 1),
      height: theme.spacing(sizes.default - 1),
    },
    '& .MuiSwitch-track': {
      borderRadius: 26,
      backgroundColor: theme.palette.grey[200],
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(sizes.smallDown),
      width: theme.spacing(sizes.smallDown * 2),
      '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
          transform: `translateX(${theme.spacing(sizes.smallDown)})`,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: theme.spacing(sizes.smallDown - 1),
        height: theme.spacing(sizes.smallDown - 1),
      },
    },
  }
})

export const KSwitchField = ({
  label,
  checked,
  disabled,
  onChange,
}: KSwitchProps) => {
  return (
    <FormControlLabel
      sx={{ mx: 0 }}
      labelPlacement="start"
      label={label}
      disabled={disabled}
      control={<KSwitch sx={{ m: 1 }} checked={checked} onChange={onChange} />}
    />
  )
}
